import Dropdown from '@admin/components/form/dropdown'
import PropTypes from 'prop-types'
import React from 'react'

class VisibilityField extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.any,
    value: PropTypes.any,
    website: PropTypes.object,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  static defaultProps = {
    onChange: () => {},
    onReady: () => {}
  }

  state = {
    visibility: null
  }

  _handleChange = _.debounce(this._handleChange.bind(this), 100, { trailing: true })
  _handleUpdate = this._handleUpdate.bind(this)

  render() {
    if(!this.state.visibility) return null
    return <Dropdown { ...this._getDropdown() } />
  }

  componentDidMount() {
    const defaultValue = this._getDefaultValue()
    this._handleSet(defaultValue)
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.props
    const { visibility } = this.state
    if(!_.isEqual(visibility, prevState.visibility)) {
      this._handleChange()
    }
    if(!_.isEqual(value, prevProps.value)) {
      this._handleSet(value)
    }
  }

  _getDefaultValue() {
    const { defaultValue, value } = this.props
    return !_.isNil(value) ? value : !_.isNil(defaultValue) ? defaultValue : null
  }

  _getDropdown() {
    const { visibility } = this.state
    return {
      options: [
        { text: 't(Show Element)', value: 'show' },
        { text: 't(Hide Element)', value: 'hide' }
      ],
      value: visibility,
      onChange: this._handleUpdate
    }
  }

  _handleChange() {
    const { visibility } = this.state
    this.props.onChange(visibility)
  }

  _handleSet(visibility) {
    this.setState({
      visibility: visibility || 'show'
    })
  }

  _handleUpdate(visibility) {
    this.setState({ visibility })
  }

}

export default VisibilityField
